import React from 'react'
import Select from '../Atoms/Select/Select'
import { SelectOption } from '../Atoms/Select/Select.types'

type AnalysisToken = { type: string; value: string }

type ValueFieldConfig = {
    field?: {
        customFieldLabel?: string
        analysisTerm?: AnalysisToken[]
    }
}

type Props = {
    onChange: (value: string) => void
    value?: string
    widgetConfiguration?: {
        valueFields?: ValueFieldConfig[]
    }
}

function getColumnLabel(valueField: ValueFieldConfig, index: number): string {
    if (valueField.field?.customFieldLabel) {
        return valueField.field.customFieldLabel
    }
    const firstValueToken = valueField.field?.analysisTerm?.find((t) => t.type === 'ValueField')
    if (firstValueToken?.value) {
        return firstValueToken.value
    }
    return `Column ${index + 1}`
}

const PivotTableSortEditor: React.FC<Props> = ({ onChange, value, widgetConfiguration }) => {
    const valueFields = widgetConfiguration?.valueFields ?? []

    const columnOptions: SelectOption[] = valueFields.map((vf, i) => ({
        value: `valueColumn:${i}`,
        label: getColumnLabel(vf, i),
    }))

    const options: SelectOption[] = [
        { value: 'label', label: 'Label (A → Z)' },
        { value: 'docCount', label: 'Document Count' },
        ...columnOptions,
    ]

    return (
        <Select
            options={options}
            value={value ?? 'label'}
            onChange={onChange}
            isClearable={false}
            isSearchable={false}
        />
    )
}

export default PivotTableSortEditor
